export const themeColors = {
  'Blue Dark': {
    'AB - Surface/Background AB - Same': '#000000',
    'AB - Surface/Background AB - Theme': '#000000',
    'AB - Surface/BG Gradient colour 01': '#000000',
    'AB - Surface/BG Gradient colour 02': '#000000',
    'N Button/Disabled': '#003D80',
    'N Button/Enable': '#1485FF',
    'N Button/Hover': '#007AFF',
    'N Button/Pressed': '#006ADE',
    'N Charts/Blue': '#1485FF',
    'N Charts/Green': '#1BC481',
    'N Charts/Lime Green': '#99EE38',
    'N Charts/Orange': '#FF9230',
    'N Charts/Purple': '#DB34F2',
    'N Charts/Red': '#FF4245',
    'N Charts/Teal': '#00D2E0',
    'N Content/Disabled': '#6E6E6E',
    'N Content/Highlighted': '#1485FF',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFF5C',
    'N Content/Inverse WB': '#000000',
    'N Content/Primary': '#FFFFFF',
    'N Content/Secondary': '#C6C4C4',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#1485FF',
    'N General/Error': '#FF4245',
    'N General/Good': '#1485FF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#1485FF',
    'N Outline/Brand Hover': '#007AFF',
    'N Outline/Brand Selected': '#1485FF',
    'N Outline/Error': '#FF4245',
    'N Outline/Primary': '#242424',
    'N Outline/Secondary': '#1D1D1D',
    'N Outline/Tertiary': '#0F0F0F',
    'N Special/Gold': '#E4AF00',
    'N Special/Gold Transparent': '#E4AF0047',
    'N Special/Promocode': '#1BC481',
    'N Special/Promocode Transparent': '#1BC48147',
    'N Special/Scratch Area Gold': '#89620047',
    'N Special/Scratch Area Team': '#003D80',
    'N Special/Scratch Area Team Dark': '#015FC53D',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#FFFFFF',
    'N Surface/Base': '#000000',
    'N Surface/BG Blur Base': '#0000005C',
    'N Surface/BG Blur Primary': '#0000005C',
    'N Surface/Brand': '#1485FF3D',
    'N Surface/Error': '#FF424547',
    'N Surface/Good': '#1485FF3D',
    'N Surface/Primary': '#242424',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#1D1D1D',
    'N Surface/Success': '#1BC48147',
    'N Surface/Warning': '#FF923047',
  },
  'Blue Light': {
    'AB - Surface/Background AB - Same': '#F8F6F3',
    'AB - Surface/Background AB - Theme': '#F3F5F8',
    'AB - Surface/BG Gradient colour 01': '#FFF6EE',
    'AB - Surface/BG Gradient colour 02': '#E0EFFF',
    'N Button/Disabled': '#99CAFF',
    'N Button/Enable': '#007AFF',
    'N Button/Hover': '#208BFF',
    'N Button/Pressed': '#60ACFF',
    'N Charts/Blue': '#007AFF',
    'N Charts/Green': '#02BE73',
    'N Charts/Lime Green': '#8DDD33',
    'N Charts/Orange': '#FF8D28',
    'N Charts/Purple': '#BF00EA',
    'N Charts/Red': '#FF383C',
    'N Charts/Teal': '#00C3D0',
    'N Content/Disabled': '#C6C4C4',
    'N Content/Highlighted': '#007AFF',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFFA3',
    'N Content/Inverse WB': '#FFFFFF',
    'N Content/Primary': '#000000',
    'N Content/Secondary': '#6E6E6E',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#007AFF',
    'N General/Error': '#FF383C',
    'N General/Good': '#007AFF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#007AFF',
    'N Outline/Brand Hover': '#208BFF',
    'N Outline/Brand Selected': '#007AFF',
    'N Outline/Error': '#FF383C',
    'N Outline/Primary': '#FFFFFF',
    'N Outline/Secondary': '#EEEEEE',
    'N Outline/Tertiary': '#F5F5F5',
    'N Special/Gold': '#F4BB00',
    'N Special/Gold Transparent': '#F4BB001F',
    'N Special/Promocode': '#02BE73',
    'N Special/Promocode Transparent': '#02BE7314',
    'N Special/Scratch Area Gold': '#89620029',
    'N Special/Scratch Area Team': '#99CAFF',
    'N Special/Scratch Area Team Dark': '#015FC529',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#1434CB',
    'N Surface/Base': '#F5F5F5',
    'N Surface/BG Blur Base': '#F5F5F5A3',
    'N Surface/BG Blur Primary': '#FFFFFFA3',
    'N Surface/Brand': '#007AFF1F',
    'N Surface/Error': '#FF383C14',
    'N Surface/Good': '#007AFF1F',
    'N Surface/Primary': '#FFFFFF',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#EEEEEE',
    'N Surface/Success': '#02BE7314',
    'N Surface/Warning': '#FF8D2814',
  },
  'Brown Light': {
    'AB - Surface/Background AB - Same': '#F8F6F3',
    'AB - Surface/Background AB - Theme': '#F8F5F3',
    'AB - Surface/BG Gradient colour 01': '#FFF6EE',
    'AB - Surface/BG Gradient colour 02': '#EEE4DF',
    'N Button/Disabled': '#D1B7AA',
    'N Button/Enable': '#B28772',
    'N Button/Hover': '#BA9380',
    'N Button/Pressed': '#C19F8E',
    'N Charts/Blue': '#007AFF',
    'N Charts/Green': '#02BE73',
    'N Charts/Lime Green': '#8DDD33',
    'N Charts/Orange': '#FF8D28',
    'N Charts/Purple': '#BF00EA',
    'N Charts/Red': '#FF383C',
    'N Charts/Teal': '#00C3D0',
    'N Content/Disabled': '#C6C4C4',
    'N Content/Highlighted': '#B28772',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFFA3',
    'N Content/Inverse WB': '#FFFFFF',
    'N Content/Primary': '#000000',
    'N Content/Secondary': '#6E6E6E',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#B28772',
    'N General/Error': '#FF383C',
    'N General/Good': '#007AFF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#B28772',
    'N Outline/Brand Hover': '#BA9380',
    'N Outline/Brand Selected': '#B28772',
    'N Outline/Error': '#FF383C',
    'N Outline/Primary': '#FFFFFF',
    'N Outline/Secondary': '#EEEEEE',
    'N Outline/Tertiary': '#F5F5F5',
    'N Special/Gold': '#F4BB00',
    'N Special/Gold Transparent': '#F4BB001F',
    'N Special/Promocode': '#02BE73',
    'N Special/Promocode Transparent': '#02BE7314',
    'N Special/Scratch Area Gold': '#89620029',
    'N Special/Scratch Area Team': '#D1B7AA',
    'N Special/Scratch Area Team Dark': '#87665629',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#1434CB',
    'N Surface/Base': '#F5F5F5',
    'N Surface/BG Blur Base': '#F5F5F5A3',
    'N Surface/BG Blur Primary': '#FFFFFFA3',
    'N Surface/Brand': '#B287721F',
    'N Surface/Error': '#FF383C14',
    'N Surface/Good': '#007AFF1F',
    'N Surface/Primary': '#FFFFFF',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#EEEEEE',
    'N Surface/Success': '#02BE7314',
    'N Surface/Warning': '#FF8D2814',
  },
  'Cool Grey Dark': {
    'AB - Surface/Background AB - Same': '#000000',
    'AB - Surface/Background AB - Theme': '#000000',
    'AB - Surface/BG Gradient colour 01': '#000000',
    'AB - Surface/BG Gradient colour 02': '#000000',
    'N Button/Disabled': '#414A5B',
    'N Button/Enable': '#7C88A2',
    'N Button/Hover': '#6D7B98',
    'N Button/Pressed': '#626F89',
    'N Charts/Blue': '#1485FF',
    'N Charts/Green': '#1BC481',
    'N Charts/Lime Green': '#99EE38',
    'N Charts/Orange': '#FF9230',
    'N Charts/Purple': '#DB34F2',
    'N Charts/Red': '#FF4245',
    'N Charts/Teal': '#00D2E0',
    'N Content/Disabled': '#6E6E6E',
    'N Content/Highlighted': '#7C88A2',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFF5C',
    'N Content/Inverse WB': '#000000',
    'N Content/Primary': '#FFFFFF',
    'N Content/Secondary': '#C6C4C4',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#7C88A2',
    'N General/Error': '#FF4245',
    'N General/Good': '#1485FF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#7C88A2',
    'N Outline/Brand Hover': '#6D7B98',
    'N Outline/Brand Selected': '#7C88A2',
    'N Outline/Error': '#FF4245',
    'N Outline/Primary': '#242424',
    'N Outline/Secondary': '#1D1D1D',
    'N Outline/Tertiary': '#0F0F0F',
    'N Special/Gold': '#E4AF00',
    'N Special/Gold Transparent': '#E4AF0047',
    'N Special/Promocode': '#1BC481',
    'N Special/Promocode Transparent': '#1BC48147',
    'N Special/Scratch Area Gold': '#89620047',
    'N Special/Scratch Area Team': '#414A5B',
    'N Special/Scratch Area Team Dark': '#4F596D47',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#FFFFFF',
    'N Surface/Base': '#000000',
    'N Surface/BG Blur Base': '#0000005C',
    'N Surface/BG Blur Primary': '#0000005C',
    'N Surface/Brand': '#7C88A247',
    'N Surface/Error': '#FF424547',
    'N Surface/Good': '#1485FF3D',
    'N Surface/Primary': '#242424',
    'N Surface/Screen Dim': '#0000005C',
    'N Surface/Secondary': '#1D1D1D',
    'N Surface/Success': '#1BC48147',
    'N Surface/Warning': '#FF923047',
  },
  'Coral Light': {
    'AB - Surface/Background AB - Same': '#F8F6F3',
    'AB - Surface/Background AB - Theme': '#F8F5F3',
    'AB - Surface/BG Gradient colour 01': '#FFF6EE',
    'AB - Surface/BG Gradient colour 02': '#EEE4DF',
    'N Button/Disabled': '#F5BEB0',
    'N Button/Enable': '#EF927B',
    'N Button/Hover': '#F19D88',
    'N Button/Pressed': '#F2A895',
    'N Charts/Blue': '#007AFF',
    'N Charts/Green': '#02BE73',
    'N Charts/Lime Green': '#8DDD33',
    'N Charts/Orange': '#FF8D28',
    'N Charts/Purple': '#BF00EA',
    'N Charts/Red': '#FF383C',
    'N Charts/Teal': '#00C3D0',
    'N Content/Disabled': '#C6C4C4',
    'N Content/Highlighted': '#FA9379',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFFA3',
    'N Content/Inverse WB': '#FFFFFF',
    'N Content/Primary': '#000000',
    'N Content/Secondary': '#6E6E6E',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#EF927B',
    'N General/Error': '#FF383C',
    'N General/Good': '#007AFF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#EF927B',
    'N Outline/Brand Hover': '#F19D88',
    'N Outline/Brand Selected': '#EF927B',
    'N Outline/Error': '#FF383C',
    'N Outline/Primary': '#FFFFFF',
    'N Outline/Secondary': '#EEEEEE',
    'N Outline/Tertiary': '#F5F5F5',
    'N Special/Gold': '#F4BB00',
    'N Special/Gold Transparent': '#F4BB001F',
    'N Special/Promocode': '#007AFF',
    'N Special/Promocode Transparent': '#007AFF1F',
    'N Special/Scratch Area Gold': '#89620029',
    'N Special/Scratch Area Team': '#F5BEB0',
    'N Special/Scratch Area Team Dark': '#D4816C29',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#1434CB',
    'N Surface/Base': '#F5F5F5',
    'N Surface/BG Blur Base': '#F5F5F5A3',
    'N Surface/BG Blur Primary': '#FFFFFFA3',
    'N Surface/Brand': '#EF927B1F',
    'N Surface/Error': '#FF383C14',
    'N Surface/Good': '#007AFF1F',
    'N Surface/Primary': '#FFFFFF',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#EEEEEE',
    'N Surface/Success': '#02BE7314',
    'N Surface/Warning': '#FF8D2814',
  },
  'Emerald Green Light': {
    'AB - Surface/Background AB - Same': '#F8F6F3',
    'AB - Surface/Background AB - Theme': '#F3F8F8',
    'AB - Surface/BG Gradient colour 01': '#FFF6EE',
    'AB - Surface/BG Gradient colour 02': '#EBFAF4',
    'N Button/Disabled': '#6CC2AE',
    'N Button/Enable': '#009B77',
    'N Button/Hover': '#1CAF8D',
    'N Button/Pressed': '#34B698',
    'N Charts/Blue': '#007AFF',
    'N Charts/Green': '#02BE73',
    'N Charts/Lime Green': '#8DDD33',
    'N Charts/Orange': '#FF8D28',
    'N Charts/Purple': '#BF00EA',
    'N Charts/Red': '#FF383C',
    'N Charts/Teal': '#00C3D0',
    'N Content/Disabled': '#C6C4C4',
    'N Content/Highlighted': '#009B77',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFFA3',
    'N Content/Inverse WB': '#FFFFFF',
    'N Content/Primary': '#000000',
    'N Content/Secondary': '#6E6E6E',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#009B77',
    'N General/Error': '#FF383C',
    'N General/Good': '#007AFF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#009B77',
    'N Outline/Brand Hover': '#1CAF8D',
    'N Outline/Brand Selected': '#009B77',
    'N Outline/Error': '#FF383C',
    'N Outline/Primary': '#FFFFFF',
    'N Outline/Secondary': '#EEEEEE',
    'N Outline/Tertiary': '#F5F5F5',
    'N Special/Gold': '#F4BB00',
    'N Special/Gold Transparent': '#F4BB001F',
    'N Special/Promocode': '#007AFF',
    'N Special/Promocode Transparent': '#007AFF1F',
    'N Special/Scratch Area Gold': '#89620029',
    'N Special/Scratch Area Team': '#6CC2AE',
    'N Special/Scratch Area Team Dark': '#00715729',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#1434CB',
    'N Surface/Base': '#F5F5F5',
    'N Surface/BG Blur Base': '#F5F5F5A3',
    'N Surface/BG Blur Primary': '#FFFFFFA3',
    'N Surface/Brand': '#009B771F',
    'N Surface/Error': '#FF383C14',
    'N Surface/Good': '#007AFF1F',
    'N Surface/Primary': '#FFFFFF',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#EEEEEE',
    'N Surface/Success': '#02BE7314',
    'N Surface/Warning': '#FF8D2814',
  },
  'Sand Military Dark': {
    'AB - Surface/Background AB - Same': '#000000',
    'AB - Surface/Background AB - Theme': '#000000',
    'AB - Surface/BG Gradient colour 01': '#000000',
    'AB - Surface/BG Gradient colour 02': '#000000',
    'N Button/Disabled': '#373226',
    'N Button/Enable': '#83785A',
    'N Button/Hover': '#9C937B',
    'N Button/Pressed': '#9C937B',
    'N Charts/Blue': '#1485FF',
    'N Charts/Green': '#1BC481',
    'N Charts/Lime Green': '#99EE38',
    'N Charts/Orange': '#FF9230',
    'N Charts/Purple': '#DB34F2',
    'N Charts/Red': '#FF4245',
    'N Charts/Teal': '#00D2E0',
    'N Content/Disabled': '#6E6E6E',
    'N Content/Highlighted': '#9C937B',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFF5C',
    'N Content/Inverse WB': '#000000',
    'N Content/Primary': '#FFFFFF',
    'N Content/Secondary': '#C6C4C4',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#83785A',
    'N General/Error': '#FF4245',
    'N General/Good': '#1485FF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#83785A',
    'N Outline/Brand Hover': '#9C937B',
    'N Outline/Brand Selected': '#83785A',
    'N Outline/Error': '#FF4245',
    'N Outline/Primary': '#242424',
    'N Outline/Secondary': '#1D1D1D',
    'N Outline/Tertiary': '#0F0F0F',
    'N Special/Gold': '#E4AF00',
    'N Special/Gold Transparent': '#E4AF0047',
    'N Special/Promocode': '#1485FF',
    'N Special/Promocode Transparent': '#1485FF3D',
    'N Special/Scratch Area Gold': '#89620047',
    'N Special/Scratch Area Team': '#373226',
    'N Special/Scratch Area Team Dark': '#E2E0DB',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#FFFFFF',
    'N Surface/Base': '#000000',
    'N Surface/BG Blur Base': '#0000005C',
    'N Surface/BG Blur Primary': '#0000005C',
    'N Surface/Brand': '#83785A47',
    'N Surface/Error': '#F19D8847',
    'N Surface/Good': '#1485FF3D',
    'N Surface/Primary': '#242424',
    'N Surface/Screen Dim': '#0000005C',
    'N Surface/Secondary': '#1D1D1D',
    'N Surface/Success': '#1BC48147',
    'N Surface/Warning': '#FF923047',
  },
  'Sand Military Light': {
    'AB - Surface/Background AB - Same': '#F8F6F3',
    'AB - Surface/Background AB - Theme': '#F2EEE2',
    'AB - Surface/BG Gradient colour 01': '#EEE4DF',
    'AB - Surface/BG Gradient colour 02': '#E2E0DB',
    'N Button/Disabled': '#948E7D',
    'N Button/Enable': '#6E654C',
    'N Button/Hover': '#58513C',
    'N Button/Pressed': '#474131',
    'N Charts/Blue': '#007AFF',
    'N Charts/Green': '#02BE73',
    'N Charts/Lime Green': '#8DDD33',
    'N Charts/Orange': '#FF8D28',
    'N Charts/Purple': '#BF00EA',
    'N Charts/Red': '#FF383C',
    'N Charts/Teal': '#00C3D0',
    'N Content/Disabled': '#C6C4C4',
    'N Content/Highlighted': '#6E654C',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFFA3',
    'N Content/Inverse WB': '#FFFFFF',
    'N Content/Primary': '#000000',
    'N Content/Secondary': '#6E6E6E',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#6E654C',
    'N General/Error': '#FF383C',
    'N General/Good': '#007AFF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#6E654C',
    'N Outline/Brand Hover': '#58513C',
    'N Outline/Brand Selected': '#6E654C',
    'N Outline/Error': '#FF383C',
    'N Outline/Primary': '#FFFFFF',
    'N Outline/Secondary': '#EEEEEE',
    'N Outline/Tertiary': '#F5F5F5',
    'N Special/Gold': '#F4BB00',
    'N Special/Gold Transparent': '#F4BB001F',
    'N Special/Promocode': '#007AFF',
    'N Special/Promocode Transparent': '#007AFF1F',
    'N Special/Scratch Area Gold': '#89620029',
    'N Special/Scratch Area Team': '#948E7D',
    'N Special/Scratch Area Team Dark': '#6E654C29',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#1434CB',
    'N Surface/Base': '#F5F5F5',
    'N Surface/BG Blur Base': '#F5F5F5A3',
    'N Surface/BG Blur Primary': '#FFFFFFA3',
    'N Surface/Brand': '#6E654C1F',
    'N Surface/Error': '#FF383C14',
    'N Surface/Good': '#007AFF1F',
    'N Surface/Primary': '#FFFFFF',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#EEEEEE',
    'N Surface/Success': '#02BE7314',
    'N Surface/Warning': '#FF8D2814',
  },
  'Soft Orchid Light': {
    'AB - Surface/Background AB - Same': '#F8F6F3',
    'AB - Surface/Background AB - Theme': '#F5F3F8',
    'AB - Surface/BG Gradient colour 01': '#FFF6EE',
    'AB - Surface/BG Gradient colour 02': '#F5F1F6',
    'N Button/Disabled': '#CFB8D3',
    'N Button/Enable': '#AF88B6',
    'N Button/Hover': '#B794BD',
    'N Button/Pressed': '#BFA0C5',
    'N Charts/Blue': '#007AFF',
    'N Charts/Green': '#02BE73',
    'N Charts/Lime Green': '#8DDD33',
    'N Charts/Orange': '#FF8D28',
    'N Charts/Purple': '#BF00EA',
    'N Charts/Red': '#FF383C',
    'N Charts/Teal': '#00C3D0',
    'N Content/Disabled': '#C6C4C4',
    'N Content/Highlighted': '#B973C7',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFFA3',
    'N Content/Inverse WB': '#FFFFFF',
    'N Content/Primary': '#000000',
    'N Content/Secondary': '#6E6E6E',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#AF88B6',
    'N General/Error': '#FF383C',
    'N General/Good': '#007AFF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#AF88B6',
    'N Outline/Brand Hover': '#B794BD',
    'N Outline/Brand Selected': '#AF88B6',
    'N Outline/Error': '#FF383C',
    'N Outline/Primary': '#FFFFFF',
    'N Outline/Secondary': '#EEEEEE',
    'N Outline/Tertiary': '#F5F5F5',
    'N Special/Gold': '#F4BB00',
    'N Special/Gold Transparent': '#F4BB001F',
    'N Special/Promocode': '#02BE73',
    'N Special/Promocode Transparent': '#02BE7314',
    'N Special/Scratch Area Gold': '#89620029',
    'N Special/Scratch Area Team': '#CFB8D3',
    'N Special/Scratch Area Team Dark': '#7E628329',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#1434CB',
    'N Surface/Base': '#F5F5F5',
    'N Surface/BG Blur Base': '#F5F5F5A3',
    'N Surface/BG Blur Primary': '#FFFFFFA3',
    'N Surface/Brand': '#AF88B61F',
    'N Surface/Error': '#FF383C14',
    'N Surface/Good': '#007AFF1F',
    'N Surface/Primary': '#FFFFFF',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#EEEEEE',
    'N Surface/Success': '#02BE7314',
    'N Surface/Warning': '#FF8D2814',
  },
  'Soft Periwinkle Light': {
    'AB - Surface/Background AB - Same': '#F8F6F3',
    'AB - Surface/Background AB - Theme': '#F3F5F8',
    'AB - Surface/BG Gradient colour 01': '#FFF6EE',
    'AB - Surface/BG Gradient colour 02': '#F3F5FB',
    'N Button/Disabled': '#C2CFEC',
    'N Button/Enable': '#99AFDF',
    'N Button/Hover': '#A3B7E2',
    'N Button/Pressed': '#ADBFE5',
    'N Charts/Blue': '#007AFF',
    'N Charts/Green': '#02BE73',
    'N Charts/Lime Green': '#8DDD33',
    'N Charts/Orange': '#FF8D28',
    'N Charts/Purple': '#BF00EA',
    'N Charts/Red': '#FF383C',
    'N Charts/Teal': '#00C3D0',
    'N Content/Disabled': '#C6C4C4',
    'N Content/Highlighted': '#6B8BD3',
    'N Content/Inverse': '#FFFFFF',
    'N Content/Inverse Disabled': '#FFFFFFA3',
    'N Content/Inverse WB': '#FFFFFF',
    'N Content/Primary': '#000000',
    'N Content/Secondary': '#6E6E6E',
    'N Content/Tertiary': '#9E9E9E',
    'N General/Brand': '#99AFDF',
    'N General/Error': '#FF383C',
    'N General/Good': '#007AFF',
    'N General/Success': '#02BE73',
    'N General/Warning': '#FF8D28',
    'N Outline/Brand': '#99AFDF',
    'N Outline/Brand Hover': '#A3B7E2',
    'N Outline/Brand Selected': '#99AFDF',
    'N Outline/Error': '#FF383C',
    'N Outline/Primary': '#FFFFFF',
    'N Outline/Secondary': '#EEEEEE',
    'N Outline/Tertiary': '#F5F5F5',
    'N Special/Gold': '#F4BB00',
    'N Special/Gold Transparent': '#F4BB001F',
    'N Special/Promocode': '#02BE73',
    'N Special/Promocode Transparent': '#02BE7314',
    'N Special/Scratch Area Gold': '#89620029',
    'N Special/Scratch Area Team': '#C2CFEC',
    'N Special/Scratch Area Team Dark': '#7C8DB329',
    'N Special/Text Black': '#000000',
    'N Special/VISA Logo': '#1434CB',
    'N Surface/Base': '#F5F5F5',
    'N Surface/BG Blur Base': '#F5F5F5A3',
    'N Surface/BG Blur Primary': '#FFFFFFA3',
    'N Surface/Brand': '#99AFDF1F',
    'N Surface/Error': '#FF383C14',
    'N Surface/Good': '#007AFF1F',
    'N Surface/Primary': '#FFFFFF',
    'N Surface/Screen Dim': '#0000003D',
    'N Surface/Secondary': '#EEEEEE',
    'N Surface/Success': '#02BE7314',
    'N Surface/Warning': '#FF8D2814',
  },
}
